<span>&nbsp;
    <i class="fas fa-chevron-up" *ngIf="sortAscending"></i>
    <i class="fas fa-chevron-down" *ngIf="!sortAscending"></i>
</span>